/*
 *
 * File JS componente block video
 *
 */

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./block-video.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockVideo = () => {};

export default blockVideo;

//--------------------------------------------------------------------//
